/* eslint-disable */
import React, { forwardRef, useMemo } from 'react'

import QRCode from 'qrcode.react'
import bordaEsquerdaFrente from 'src/assets/imagens/certificado-extensao/borda-esquerda-frente.png'
import bordaEsquerdaVerso from 'src/assets/imagens/certificado-extensao/borda-esquerda-verso.png'
import bordaDireitaVerso from 'src/assets/imagens/certificado-extensao/borda-direita-verso.png'
import logoIpgsEducacao from 'src/assets/imagens/certificado-extensao/logo-ipgs-educacao.png'
import imagemAssinatura from 'src/assets/imagens/imagem-assinatura.png'
import { FuncoesDataHora } from 'src/componentes'
import { RotasApp } from 'src/rotas'
import { DadosCertificado } from 'src/servicos/api/sala-aula/tipos'

import SalaAulaContainer from '../container'
import {
  nomeCertificadoEstaVazio,
  textoNomeNoCertificado
} from './nome-preview'
import {
  AreaAssinatura,
  AreaConteudo,
  AreaQrCode,
  BordaDireita,
  BordaLateral,
  BordaLateralFrente,
  CabecalhoVerso,
  ContainerCertificadoExtensao,
  ConteudoVerso,
  DataLocal,
  LegendaRodape,
  LinhaAssinatura,
  LinhaAssinaturaQr,
  LogoTopo,
  NomeAluno,
  PaginaFrente,
  PaginaVerso,
  RealizacaoVerso,
  RodapeFrente,
  RodapeVerso,
  Subtitulo,
  TextoCorpo,
  TituloPrincipal
} from './styles-extensao'

export const CertificadoExtensaoTemplate = forwardRef<
  HTMLDivElement,
  { certificado: DadosCertificado }
>(({ certificado }, ref) => {
  const { idMatricula } = SalaAulaContainer.useContainer()

  const urlQRCode = useMemo(
    () =>
      `${process.env.REACT_APP_URL}${RotasApp.ValidacaoCertificado}/${idMatricula}`,
    [idMatricula]
  )

  return (
    <ContainerCertificadoExtensao ref={ref}>
      <PaginaFrente>
        <BordaLateralFrente src={bordaEsquerdaFrente} alt="" />
        <AreaConteudo>
          <LogoTopo src={logoIpgsEducacao} alt="iPGS Educação em Saúde e Nutrição" />
          <TituloPrincipal>CERTIFICADO DE CONCLUSÃO</TituloPrincipal>
          <Subtitulo>CURSO DE EXTENSÃO</Subtitulo>
          <TextoCorpo>A IPGS Educação certifica que</TextoCorpo>
          <NomeAluno
            className={
              nomeCertificadoEstaVazio(certificado.nome)
                ? 'nome-placeholder'
                : undefined
            }
          >
            {textoNomeNoCertificado(certificado.nome)}
          </NomeAluno>
          <TextoCorpo>
            participou do curso de extensão {certificado.nomeCurso}, totalizando{' '}
            {certificado.cargaHoraria} horas de atividades.
          </TextoCorpo>
          <DataLocal>
            Porto Alegre, {FuncoesDataHora.dataFormatadaMesEscrito(new Date())}
          </DataLocal>
          <RodapeFrente>
            <LinhaAssinaturaQr>
              <AreaAssinatura>
                <img src={imagemAssinatura} alt="Assinatura" />
                <LinhaAssinatura />
              </AreaAssinatura>
              <AreaQrCode>
                <QRCode value={urlQRCode} size={96} includeMargin />
              </AreaQrCode>
            </LinhaAssinaturaQr>
            <LegendaRodape>
              <span>Acadêmico</span>
              <span>
                Aline Petter Schneider
                <br />
                <span className="secundario">
                  Credenciamento da Faculdade iPGS
                </span>
              </span>
              <span>
                Diretora Geral IPGS
                <br />
                <span className="secundario">MEC - Ministério da Educação</span>
              </span>
            </LegendaRodape>
          </RodapeFrente>
        </AreaConteudo>
      </PaginaFrente>

      <PaginaVerso>
        <BordaLateral src={bordaEsquerdaVerso} alt="" />
        <AreaConteudo>
          <CabecalhoVerso>ASSUNTOS ABORDADOS NESTE CURSO:</CabecalhoVerso>
          <ConteudoVerso
            dangerouslySetInnerHTML={{ __html: certificado.versoCertificado }}
          />
          <RodapeVerso>
            <QRCode value={urlQRCode} size={88} includeMargin />
            <RealizacaoVerso>
              <span>Realização:</span>
              <img src={logoIpgsEducacao} alt="iPGS Educação em Saúde e Nutrição" />
            </RealizacaoVerso>
          </RodapeVerso>
        </AreaConteudo>
        <BordaDireita src={bordaDireitaVerso} alt="" />
      </PaginaVerso>
    </ContainerCertificadoExtensao>
  )
})
